
export const GET_ALL_FILE = "GET_ALL_FILE";
export const DOWNLOAD_FILE = "DOWNLOAD_FILE";


